import React from 'react';

const LoadingSpinner = ({ textColor = '#666' }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px',
      minHeight: '200px',
    }}
    data-widget-element="loading-spinner"
    role="status"
    aria-live="polite"
  >
    <img
      src="https://d2atdwxjx7uc4i.cloudfront.net/images/bx_loader.gif"
      width="40"
      alt=""
      aria-hidden="true"
    />
    <div style={{ marginTop: '12px', color: textColor, fontSize: '14px' }}>
      {t('quote_builder_widget.loading')}
    </div>
  </div>
);

export default LoadingSpinner;
